import type React from "react";

export const ServiceEndNotice: React.FC = () => (
  <section
    aria-label="重要なお知らせ"
    className="mb-6 rounded-[4px] border border-amber-300 bg-amber-50 p-4 text-sm text-gray-900"
  >
    <p className="mb-2 font-bold">重要なお知らせ</p>
    <p>
      レクシン AI for kintone は 2027年1月29日（金）をもってサービスを終了します。
      <br />
      これに伴い、2026年10月29日（木）より有償プランの新規契約・プラン変更の受付を停止します。
    </p>
    <p className="mt-2 text-xs text-gray-700">
      ※現在のプラン・クレジット残量・クレジット履歴は、サービス終了日までこれまでどおりご確認いただけます。
    </p>
  </section>
);
